import React from 'react';
import styled from 'styled-components';
import useScreenSize from '@source/hooks/useScreenSize';
import { buildI18KeyResponsive, getResponsiveContent } from '@source/hooks/useResponsiveContent';
import { Trans } from 'next-i18next';
import StyledContainer from '@design-system/styled/Container';

export interface WhyChooseCarroProps {
  content: {
    title: string;
    description: string;
  };
}

const StyledWhyChooseCarro = styled(StyledContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding-top: 55px;
  padding-bottom: 45px;
`;

const StyledTitle = styled.span`
  ${(props) => props.theme.typo.familyGoogle.semiBold};
  font-size: 22px;
  line-height: 32px;
  text-align: center;
  color: ${(props) => props.theme.color.lightOrange};

  @media screen and (min-width: ${(props) => props.theme.metrics.breakpoints.md}) {
    ${(props) => props.theme.typo.familyGoogle.medium};
    font-size: 33px;
    line-height: 32px;
  }
`;

const StyledDescription = styled.span`
  ${(props) => props.theme.typo.familyGoogle.regular};
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${(props) => props.theme.color.onSurface};
  white-space: pre-line;

  @media screen and (min-width: ${(props) => props.theme.metrics.breakpoints.md}) {
    font-size: 16px;
    line-height: 22px;
  }
`;

const WhyChooseCarro: React.FC<WhyChooseCarroProps> = ({ content }) => {
  const { title, description } = content;

  const breakpoint = useScreenSize();

  const tTitle = getResponsiveContent(buildI18KeyResponsive(title, ['xs', 'md', 'lg']), breakpoint);
  const tDesc = getResponsiveContent(buildI18KeyResponsive(description, ['xs', 'md', 'lg']), breakpoint);

  return (
    <StyledWhyChooseCarro>
      <StyledTitle>
        <Trans ns="sellCar" i18nKey={tTitle} defaults={title} />
      </StyledTitle>
      <StyledDescription>
        <Trans ns="sellCar" i18nKey={tDesc} defaults={description} />
      </StyledDescription>
    </StyledWhyChooseCarro>
  );
};

export default WhyChooseCarro;
